export default "__VITE_PUBLIC_ASSET__405673e6__"